<div class="select-wrapper eu-display_flex eu-column">
    <div class="select-container emd-container">
        <i class="eu-ml_1 fa fa-search fa-lg" aria-hidden="true"></i>
        <input
            *ngIf="!selectedItem"
            [(ngModel)]="searchFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="placeholder"
            class="select-search-bar"
            type="text"
            autocomplete="off"
        />
        <div *ngIf="selectedItem" class="selected-item-container w-100">
            <span href="#" class="emd-tag _color_primary">
                {{ selectedItem.name }}
            </span>
        </div>
        <i
            class="eu-mr_1 fa fa-times-circle-o fa-lg eu-cursor_pointer"
            aria-hidden="true"
            (click)="clearSelection()"
        ></i>
    </div>
    <div
        *ngIf="filteredItems.length > 0 && !selectedItem"
        class="emd-container select-items-container"
    >
        <ul>
            <li
                *ngFor="let item of filteredItems"
                class="eu-cursor_pointer"
                (click)="onSelectNewItem(item)"
            >
                <span class="emd-text _color_subtle">{{ item.name }}</span>
            </li>
        </ul>
    </div>
</div>
